/* tslint:disable */
/* eslint-disable */
/* @relayHash 1c9459f7e83875fe0b4c1830fdcec2b8 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type App_Org_QueryVariables = {};
export type App_Org_QueryResponse = {
    readonly manager: {
        readonly " $fragmentRefs": FragmentRefs<"OrgOverview_manager">;
    } | null;
    readonly purchasedCourses: {
        readonly " $fragmentRefs": FragmentRefs<"OrgOverview_purchasedCourses">;
    } | null;
};
export type App_Org_Query = {
    readonly response: App_Org_QueryResponse;
    readonly variables: App_Org_QueryVariables;
};



/*
query App_Org_Query {
  manager {
    ...OrgOverview_manager
  }
  purchasedCourses {
    ...OrgOverview_purchasedCourses
  }
}

fragment ActivityCard_activity on ActivityPage {
  edges {
    ...UserUpdate_activity
  }
}

fragment OrgOverview_manager on Manager {
  firstName
  lastName
  email
  telephone
  lastLogin
  company {
    name
    delegates {
      pageInfo {
        total
      }
    }
    certificatesStatus {
      totals {
        available
        expired
        expiringSoon
        incomplete
      }
    }
    activity(page: {limit: 6}) {
      ...ActivityCard_activity
    }
    ...StatusCard_company
  }
}

fragment OrgOverview_purchasedCourses on PurchasedCoursePage {
  edges {
    counts {
      expiringTakers
    }
  }
}

fragment StatusCard_company on Company {
  certificatesStatus {
    secondaryCategoryStatuses {
      secondaryCategory {
        name
        uuid
      }
      totals {
        available
        expired
        expiringSoon
        incomplete
      }
    }
  }
  simulatorCompliance {
    activeUsers
    compliantUsers
    uncompliantUsers
  }
  documentStatus {
    available
    expired
    expiringSoon
    incomplete
  }
  backgroundCheckStatus {
    available
    expired
    expiringSoon
    incomplete
  }
}

fragment UserUpdate_activity on Activity {
  type
  createdAt
  course {
    __typename
    name
  }
  user {
    firstName
    lastName
    profileImageUrl
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v3 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "available",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "expired",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "expiringSoon",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "incomplete",
            "args": null,
            "storageKey": null
        } as any)
    ], v4 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "totals",
        "storageKey": null,
        "args": null,
        "concreteType": "ExpiryStatus",
        "plural": false,
        "selections": (v3 /*: any*/)
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "App_Org_Query",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "manager",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Manager",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "OrgOverview_manager",
                            "args": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "purchasedCourses",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PurchasedCoursePage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "OrgOverview_purchasedCourses",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "App_Org_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "manager",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Manager",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        (v1 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "email",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "telephone",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "lastLogin",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "company",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Company",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "delegates",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "DelegatePage",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "pageInfo",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "total",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "certificatesStatus",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CompanyCertificateStatus",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "secondaryCategoryStatuses",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SecondaryCategoryCertificateStatus",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "secondaryCategory",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "SecondaryCategory",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "uuid",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                (v4 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "activity",
                                    "storageKey": "activity(page:{\"limit\":6})",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "page",
                                            "value": {
                                                "limit": 6
                                            }
                                        }
                                    ],
                                    "concreteType": "ActivityPage",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Activity",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "type",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "createdAt",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "course",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "__typename",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "user",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "User",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        (v1 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "profileImageUrl",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "simulatorCompliance",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "SimulatorCompliance",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "activeUsers",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "compliantUsers",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "uncompliantUsers",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "documentStatus",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ExpiryStatus",
                                    "plural": false,
                                    "selections": (v3 /*: any*/)
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "backgroundCheckStatus",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ExpiryStatus",
                                    "plural": false,
                                    "selections": (v3 /*: any*/)
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "purchasedCourses",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PurchasedCoursePage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PurchasedCourse",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "counts",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PurchasedCourseCount",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "expiringTakers",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "App_Org_Query",
            "id": null,
            "text": "query App_Org_Query {\n  manager {\n    ...OrgOverview_manager\n  }\n  purchasedCourses {\n    ...OrgOverview_purchasedCourses\n  }\n}\n\nfragment ActivityCard_activity on ActivityPage {\n  edges {\n    ...UserUpdate_activity\n  }\n}\n\nfragment OrgOverview_manager on Manager {\n  firstName\n  lastName\n  email\n  telephone\n  lastLogin\n  company {\n    name\n    delegates {\n      pageInfo {\n        total\n      }\n    }\n    certificatesStatus {\n      totals {\n        available\n        expired\n        expiringSoon\n        incomplete\n      }\n    }\n    activity(page: {limit: 6}) {\n      ...ActivityCard_activity\n    }\n    ...StatusCard_company\n  }\n}\n\nfragment OrgOverview_purchasedCourses on PurchasedCoursePage {\n  edges {\n    counts {\n      expiringTakers\n    }\n  }\n}\n\nfragment StatusCard_company on Company {\n  certificatesStatus {\n    secondaryCategoryStatuses {\n      secondaryCategory {\n        name\n        uuid\n      }\n      totals {\n        available\n        expired\n        expiringSoon\n        incomplete\n      }\n    }\n  }\n  simulatorCompliance {\n    activeUsers\n    compliantUsers\n    uncompliantUsers\n  }\n  documentStatus {\n    available\n    expired\n    expiringSoon\n    incomplete\n  }\n  backgroundCheckStatus {\n    available\n    expired\n    expiringSoon\n    incomplete\n  }\n}\n\nfragment UserUpdate_activity on Activity {\n  type\n  createdAt\n  course {\n    __typename\n    name\n  }\n  user {\n    firstName\n    lastName\n    profileImageUrl\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '03cecf1c86c1493235fdce7b84acadcb';
export default node;
